import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=f412a350&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=js&"
export * from "./pagination.vue?vue&type=script&lang=js&"
import style0 from "./pagination.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./pagination.vue?vue&type=style&index=1&id=f412a350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f412a350",
  null
  
)

export default component.exports